import {
  TileLayer,
  Marker,
  LayersControl,
  ZoomControl,
  useMapEvents,
  useMap,
} from 'react-leaflet'
import {
  shopIcon,
  hoveredShopIcon,
} from '../../resort/diveResortMap/DestinationsMap'
import { OperatorListItem } from '../OperatorListItem'
import { getLanguage } from '../../../utils'
import { getMapTileUrl, isMainLand, tiandituTilesUrl } from 'config'

import '../map.scss'
import useSelectShop from './hooks/useSelectShop'
import { useEffect } from 'react'
import isEmpty from 'lodash/isEmpty'

const language = getLanguage()

export default function Map({
  pins,
  countryCode,
  slug,
  toggleMap,
  initBounds,
}) {
  const map = useMap()
  const { selectedShop, getShopInfo, closePopup } = useSelectShop()
  const tileUrl = getMapTileUrl({
    isSateliteView: false,
    countryCode: countryCode,
    language,
    isLight: true,
  })

  useEffect(() => {
    isEmpty(initBounds) ? map.setView([47, 18]) : map.fitBounds(initBounds)
  }, [initBounds])

  useMapEvents({
    click: closePopup,
  })

  return (
    <div className='map-wrapper'>
      <div className='back-button' onClick={toggleMap}>
        <i className='font-icons left-arrow-icon' />
      </div>
      {selectedShop ? <OperatorListItem item={selectedShop} /> : ''}
      <LayersControl position='topright'>
        <LayersControl.BaseLayer name='PADI Travel map' checked>
          {isMainLand(countryCode) && <TileLayer url={tiandituTilesUrl} />}
          <TileLayer url={tileUrl} />
        </LayersControl.BaseLayer>
        <LayersControl.BaseLayer name='Satellite'>
          <TileLayer url='//server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}' />
        </LayersControl.BaseLayer>
      </LayersControl>
      <ZoomControl position='topright' />
      {pins.map((item) => {
        const pin = item.point
        if(pin && pin.latitude && pin.longitude) {
          return (
            <Marker
              key={item.id}
              id={item.id}
              position={[pin.latitude, pin.longitude]}
              icon={
                selectedShop && selectedShop.id === item.id
                  ? hoveredShopIcon
                  : shopIcon
              }
              eventHandlers={{ click: () => getShopInfo(item, slug) }}
            />
          )
        }
      })}
    </div>
  )
}
